// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__14y9G","actionsCol":"EnrolledClinics_actionsCol__2SVqs"};